import React, { useState, useContext } from 'react';
import { Container, Box, TextField, Button, Typography, Alert } from '@mui/material';
import AuthContext from '../store/AuthContext';
import { Link } from 'react-router-dom';
import { isLocalEnvironment } from '../utils/environmentUtils';

function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { isAuthenticated, login, isLocalEnv } = useContext(AuthContext);

    const handleLogin = () => {
        // Pseudo authentication logic - only works in local environment
        if (!isLocalEnv) {
            setError('Admin login is only available in local development environment');
            return;
        }
        
        if (username === 'eric_rak@hotmail.com192' && password === 'eric_rak@hotmail.com192') {
            const success = login();
            if (success) {
                setError('');
            } else {
                setError('Admin login is only available in local development environment');
            }
        } else {
            setError('Invalid username or password');
        }
    };

    if (!isLocalEnv) {
        return (
            <Container maxWidth="sm">
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
                    <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
                        Admin Login
                    </Typography>
                    <Alert severity="warning" sx={{ mb: 3 }}>
                        Admin login is only available in the local development environment.
                        <br />
                        This feature is disabled on the production website for security reasons.
                    </Alert>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        component={Link} 
                        to="/"
                    >
                        Back to Home
                    </Button>
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm">
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
                <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
                    Admin Login
                </Typography>
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                {isAuthenticated ? (
                    <>
                        <Typography variant="h6" component="p" sx={{ mb: 3 }}>
                            Welcome, Admin!
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                component={Link} 
                                to="/"
                            >
                                Back to Home
                            </Button>
                            <Button 
                                variant="outlined" 
                                color="primary" 
                                component={Link} 
                                to="/project-manager"
                            >
                                Go to Project Manager
                            </Button>
                        </Box>
                    </>
                ) : (
                    <>
                        <TextField
                            label="Username"
                            variant="outlined"
                            fullWidth
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            label="Password"
                            variant="outlined"
                            type="password"
                            fullWidth
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            sx={{ mb: 2 }}
                        />
                        <Button variant="contained" color="primary" onClick={handleLogin}>
                            Login
                        </Button>
                    </>
                )}
            </Box>
        </Container>
    );
}

export default AdminLogin;
